import axios, { addInterceptors } from './interceptor-axios';
import localStorage from './localStorage';
import config, { OVERSEAS_SERVICES } from '~/config';

const OVERSEAS_API_SEARCH = config.apiOverseasSearchURL;
const OVERSEAS_API_SEARCH_PHOTO_AC = config.apiOverseasSearchPhotoACURL;
const OVERSEAS_API_DOWNLOAD_PHOTO = config.apiDownloadOverseasPhotoURL;
const OVERSEAS_API_DATA = config.apiDataOverseasURL;
const API_OVERSEAS_DETAIL_PHOTO_DATA = config.apiDetailPhotoOverseasURL;

class OverseasService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      headers,
    });
    addInterceptors(this.axios);
  }

  searchPhotosFromOverseasSite = ({ keyword, page, limit, filter }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH_PHOTO_AC,
      params: {
        keyword,
        excludeKeyword: '令和',
        category_id: '',
        excludeCategory_id: '',
        isFromSearchHeader: true,
        language: 'en',
        page,
        excludeCategoriesId: '',
        categoriesId: '',
        max_results: limit || 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        service_type: OVERSEAS_SERVICES.PHOTO_AC,
        lang: 'en',
        disp_language: 'en',
        overseas: 'true',
        site: 1,
        creator_id: 43626,
        role: 'preimum_test',
        // db: 'off',
        ...filter,
      },
    };
    return this.axios(request);
  };

  searchIllustsFromJapanSite = ({ keyword, page, limit, filter }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        keyword,
        service_type: OVERSEAS_SERVICES.ILLUST_AC,
        role: 'preimum_test',
        order_by: 'popular',
        excludeCategory_id: '107',
        excludeCategoriesId: '107',
        excludeKeyword: '令和',
        excludeTitle: 'set collection',
        shape: '',
        title: '',
        creator_id: 'acworks',
        creatorName: 'acworks',
        page,
        max_results: limit || 100,
        option: 2,
        offset: '20d',
        scale: '80d',
        decay: 0.7,
        download: 0.6,
        download_all: 0.2,
        weight: 0.5,
        rating: 1,
        factor_tag: 0.72,
        factor_localize: 0,
        log: 2,
        minscore: 0,
        tag_name: 'jp',
        language: 'jp',
        disp_flg: true,
        site: 'jp',
        country: 'jp',
        // db: 'off',
        ...filter,
      },
    };
    return this.axios(request);
  };

  searchSilhouettesFromOverseasSite = ({ keyword, page, limit, filter }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        keyword,
        // excludeKeyword: '令和',
        category_id: '',
        excludeCategory_id: '',
        isFromSearchHeader: true,
        page,
        excludeCategoriesId: '',
        categoriesId: '',
        max_results: limit || 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        service_type: OVERSEAS_SERVICES.SILHOUETTE_AC,
        tag_name: 'jp',
        language: 'jp',
        disp_flg: true,
        site: 'jp',
        country: 'jp',
        creator_id: 43626,
        role: 'preimum_test',
        // db: 'off',
        imageSize: 'psd',
        ...filter,
      },
    };
    return this.axios(request);
  };

  listPhotosByCategoryFromOverseasSite = ({
    categorySlug,
    page,
    max_results,
  }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH_PHOTO_AC,
      params: {
        category_slug: categorySlug,
        language: 'en',
        service_type: OVERSEAS_SERVICES.PHOTO_AC,
        per_page: max_results || 100,
        page,
        order_by: 'popular',
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        max_results: max_results || 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
        creator_id: 43626,
        role: 'preimum_test',
      },
    };
    return this.axios(request);
  };

  listIllustsByCategoryFromOverseasSite = ({ categorySlug, page }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        category_slug: categorySlug,
        language: 'en',
        service_type: OVERSEAS_SERVICES.ILLUST_AC,
        per_page: 100,
        page: 1,
        order_by: 'popular',
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        excludeTitle: 'set collection',
        excludeCategory_id: '107',
        excludeCategoriesId: '107',
        max_results: 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        option: 2,
        offset: '20d',
        scale: '60d',
        decay: 0.75,
        download: 0.65,
        download_all: 0.43,
        weight: 1,
        rating: 1,
        factor_tag: 1.2,
        factor_localize: 0,
        log: 2,
        minscore: 0.04,
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
        creator_id: 'acworks',
        creatorName: 'acworks',
        role: 'preimum_test',
      },
    };
    return this.axios(request);
  };

  listIllustsByCategoryFromJapanSite = ({ categorySlug, page }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        category_slug: categorySlug,
        per_page: 100,
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        excludeTitle: 'set collection',
        excludeCategory_id: '107',
        excludeCategoriesId: '107',
        service_type: OVERSEAS_SERVICES.ILLUST_AC,
        role: 'preimum_test',
        order_by: 'popular',
        shape: '',
        title: '',
        creator_id: 'acworks',
        creatorName: 'acworks',
        page,
        max_results: 100,
        // db: 'off',
        option: 2,
        offset: '20d',
        scale: '80d',
        decay: 0.7,
        download: 0.6,
        download_all: 0.2,
        weight: 0.5,
        rating: 1,
        factor_tag: 0.72,
        factor_localize: 0,
        log: 2,
        minscore: 0,
        tag_name: 'jp',
        language: 'jp',
        disp_flg: true,
        site: 'jp',
        country: 'jp',
      },
    };
    return this.axios(request);
  };

  // Load pattern by services
  listRecommendedIllust = ({ page, max_results, pattern }) => {
    let request;

    if (pattern) {
      request = {
        method: 'GET',
        url: `${OVERSEAS_API_DATA}/data/recommended`,
        params: {
          lang: 'editorAC', // lang must be editorAC
          page: page || 1,
          rand: true,
          pattern_id: pattern,
          max_results: max_results || 105,
          service_type: OVERSEAS_SERVICES.ILLUST_AC,
          language: 'en',
          disp_language: 'en',
          overseas: false,
          site: 1,
        },
      };
    } else {
      request = {
        method: 'GET',
        url: `${OVERSEAS_API_DATA}/data/recommended`,
        params: {
          lang: 'editorAC', // lang must be editorAC
          page: page || 1,
          rand: true,
          pattern_id: 67,
          max_results: max_results || 105,
          service_type: OVERSEAS_SERVICES.ILLUST_AC,
          language: 'editorAC',
          disp_language: 'editorAC',
          overseas: false,
          site: 1,
        },
      };
    }

    return this.axios(request);
  };

  listRecommendedPhoto = ({ page, max_results }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH_PHOTO_AC,
      params: {
        keyword: '日本人',
        language: 'en',
        service_type: OVERSEAS_SERVICES.PHOTO_AC,
        per_page: max_results || 105,
        page,
        order_by: 'popular',
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        max_results: max_results || 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
        creator_id: 43626,
        role: 'preimum_test',
      },
    };
    return this.axios(request);
  };

  listRecommendedSilhouette = ({ page, max_results, pattern }) => {
    const request = {
      method: 'GET',
      url: `${OVERSEAS_API_DATA}/data/recommended`,
      params: {
        lang: 'editorAC', // lang must be editorAC
        page: page || 1,
        rand: true,
        pattern_id: pattern,
        max_results: max_results || 105,
        service_type: OVERSEAS_SERVICES.SILHOUETTE_AC,
        language: 'en',
        disp_language: 'en',
        overseas: false,
        site: 1,
      },
    };
    return this.axios(request);
  };

  listPatterns = () => {
    const request = {
      method: 'GET',
      url: `${OVERSEAS_API_DATA}/pattern/editor`,
      params: {
        service_type: OVERSEAS_SERVICES.PHOTO_AC,
      },
    };
    return this.axios(request);
  };
  // End load pattern by services

  listSilhouettesByCategoryFromOverseasSite = ({
    categorySlug,
    page,
    max_results,
  }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        category_slug: categorySlug,
        language: 'en',
        service_type: OVERSEAS_SERVICES.SILHOUETTE_AC,
        per_page: max_results || 100,
        page: page || 1,
        order_by: 'popular',
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        max_results: max_results || 100,
        rate: 0.56,
        rand: true,
        pow: 1.678,
        param: 14000,
        p5: 0.9,
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
        creator_id: 43626,
        role: 'preimum_test',
      },
    };
    return this.axios(request);
  };

  downloadDataFromOverseasSite = ({ serviceType, dataID, type, format }) => {
    const request = {
      method: 'POST',
      url: OVERSEAS_API_DOWNLOAD_PHOTO,
      data: {
        service_type: serviceType,
        data_id: dataID,
        data_size: type,
        data_type: format ? format.toLowerCase() : type,
        language: 'en',
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
        role: 'preimum_test',
      },
    };
    return this.axios(request);
  };

  getDetailData = ({ serviceType, dataID }) => {
    const request = {
      method: 'GET',
      url: `${API_OVERSEAS_DETAIL_PHOTO_DATA}/data/detail`,
      params: {
        data_id: dataID,
        service_type: serviceType,
        language: 'en',
        lang: 'en',
        disp_language: 'en',
        overseas: true,
        site: 1,
      },
    };
    return this.axios(request);
  };

  getCategoryAssets = ({ serviceType, lang }) => {
    const request = {
      method: 'GET',
      url: `${OVERSEAS_API_DATA}/categories/name`,
      params: {
        lang,
        service_type: serviceType,
      },
    };
    return this.axios(request);
  };

  listNewYearByCategoryFromJapanSite = ({ keyword, max_results, page }) => {
    const request = {
      method: 'GET',
      url: OVERSEAS_API_SEARCH,
      params: {
        keyword,
        per_page: max_results || 100,
        is_tag: true,
        isCategoryPage: true,
        excludeKeyword: '令和',
        excludeTitle: 'set collection',
        excludeCategory_id: '107',
        excludeCategoriesId: '107',
        service_type: OVERSEAS_SERVICES.ILLUST_AC,
        role: 'preimum_test',
        order_by: 'popular',
        shape: '',
        title: '',
        creator_id: 'acworks',
        creatorName: 'acworks',
        page,
        max_results: max_results || 100,
        // db: 'off',
        option: 2,
        offset: '20d',
        scale: '80d',
        decay: 0.7,
        download: 0.6,
        download_all: 0.2,
        weight: 0.5,
        rating: 1,
        factor_tag: 0.72,
        factor_localize: 0,
        log: 2,
        minscore: 0,
        tag_name: 'jp',
        language: 'jp',
        disp_flg: true,
        site: 'jp',
        country: 'jp',
        categoriesId: 44,
      },
    };
    return this.axios(request);
  };
}

export default new OverseasService();
